import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

export const errMsg = (e, fallback = "Ha ocurrido un error") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg;
  return e?.message || fallback;
};

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startLogin = (next = "/dashboard") => {
  localStorage.setItem("forja_next", next);
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const fmtPrice = (agent) => {
  if (!agent || !agent.price) return "Gratis";
  const v = new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(agent.price);
  return agent.pricing_type === "monthly" ? `${v}/mes` : v;
};

export const fmtEur = (v) => new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(v || 0);
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("es-ES", { day: "2-digit", month: "short", year: "numeric" }) : "—");

export async function streamChat(body, { onMeta, onDelta, onError, signal }) {
  const res = await fetch(`${API}/chat/stream`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    signal,
  });
  if (!res.ok) {
    const j = await res.json().catch(() => ({}));
    const err = new Error(typeof j.detail === "string" ? j.detail : "No se pudo enviar el mensaje");
    err.status = res.status;
    throw err;
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split("\n\n");
    buffer = parts.pop();
    for (const part of parts) {
      const line = part.trim();
      if (!line.startsWith("data:")) continue;
      const evt = JSON.parse(line.slice(5).trim());
      if (evt.type === "meta") onMeta?.(evt);
      else if (evt.type === "delta") onDelta?.(evt.content);
      else if (evt.type === "error") onError?.(evt.message);
    }
  }
}
